import { v4 as uuid } from "uuid";

export default (type, data, metadata, id = uuid(), subItems = [], overrideSubItemId) => {
	const constructedModel = {
		type,
		data,
		metadata,
		subItems,
		id,
		overrideSubItemId,
	};

	const validator = validateShoppingCartItem;

	validator(constructedModel);

	if (validator.errors) {
		throw new Error(
			`Failed to validate item ${JSON.stringify(constructedModel)} due to error ${JSON.stringify(validator.errors)}`,
		);

		//throw new Error(JSON.stringify(validator.errors));
	}

	return constructedModel;
};
